<template>
  <div class="cycle-slideshow homeCarousel"
    data-cycle-swipe=true
    data-cycle-swipe-fx=scrollHorz
    data-cycle-fx="scrollHorz"
    data-cycle-speed="1000"
    data-cycle-timeout="5000"
    data-cycle-pager=".pager"
    data-cycle-prev=".prev"
    data-cycle-next=".next"
    data-cycle-slides="> div"
    >
      <span class="progress"></span>
      <span class="pager"></span>
      <span class="prev fa fa-chevron-left  fa-2x"></span>
      <span class="next fa fa-chevron-right fa-2x"></span>
  </div>
</template>

<script>
export default {
  name: 'home-carousel',
  props: {
    // msg: String
  },
  methods: {
    setSlideHeight: function() {
        document.querySelector(".homeCarousel").style.height = document.documentElement.clientHeight - document.querySelector("header").offsetHeight - document.querySelector("footer").offsetHeight + "px";    

        document.querySelectorAll(".homeCarousel .slide").forEach( (item) => {
            item.style.height = document.documentElement.clientHeight - document.querySelector("header").offsetHeight - document.querySelector("footer").offsetHeight + "px";
        });
      }
  },
  mounted() {
    var progress = $('.progress'),
        slideshow = $( '.cycle-slideshow' );

    slideshow.on( 'cycle-initialized cycle-before', function( e, opts) {
        console.log("before num:" + opts.slideNum);
        progress.stop(true).css( 'width', 0 );
    });

    slideshow.on( 'cycle-initialized cycle-after', function( e, opts ) {                
        console.log("after num:" + opts.slideNum);
        if ( ! slideshow.is('.cycle-paused') )
            progress.animate({ width: '100%' }, opts.timeout, 'linear' );
    });

    slideshow.on( 'cycle-initialized cycle-pager-activated cycle-next cycle-prev', function( e, opts) {
        console.log("===========================================");
        console.log("curr:" + opts.currSlide);
        console.log("next:" + opts.nextSlide);
    });

    slideshow.on( 'cycle-paused', function( e, opts ) {
        progress.stop(); 
    });

    slideshow.on( 'cycle-resumed', function( e, opts, timeoutRemaining ) {
        progress.animate({ width: '100%' }, timeoutRemaining, 'linear' );
    });

    var images = [
        // slide_0,
        slide_1,
        slide_2
    ];
    
    let _this = this;
    setTimeout(function(){
        $('.cycle-slideshow').cycle("add", images[0]);
        _this.setSlideHeight();
    }, 200);

    setTimeout(function(){
        for (var i=1; i<images.length; i++) {
            $('.cycle-slideshow').cycle("add", images[i]);
        }
        _this.setSlideHeight();
    }, 2000);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.homeCarousel {
    width: 100%;
    margin: 0 auto;
    padding: 0;
    z-index: 0;
}

.homeCarousel .slide {
    width: 100%;
    height: 750px;
    margin: 0;
    padding: 0;
    overflow: hidden;
    vertical-align: bottom;
    border: 0;  
    /* background: #ccc; */
}

.homeCarousel .progress {
    height: 5px;
    position: absolute;
    left: 0;
    bottom: 0px;
    z-index: 101;
    background: rgba(255, 255, 255, 0.5);
}

.homeCarousel .pager {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 25px;
    z-index: 101;
    text-align: center;
}

.homeCarousel .pager span  {
    width: 35px;
    height: 5px;
    margin: 3px;    
    border-radius: 1px;
    display: inline-block;
    font-size: 0px;
    color: #ddd;
    background: rgba(0, 0, 0, 0.5);
    cursor: pointer; 
}

.homeCarousel .pager span.cycle-pager-active {
    color: #0066bc;
    background: rgba(255, 255, 255, 0.5);
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
}

.homeCarousel .pager > *  {
    cursor: pointer;
}

.homeCarouselBottom {
    border-Top: solid 1px #505050;
}

.homeCarousel .prev {    
    padding: 15px 10px;
    position: absolute;
    top: 45%;
    left: 25px;
    z-index: 101;
    border-radius: 1px;
    line-height: 0.85;
    font-size: 50px;
    text-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
    color: rgb(255, 255, 255);
    cursor: pointer;    
}

.homeCarousel .next {
    padding: 15px 10px;
    display: inline-block;
    position: absolute;
    top: 45%;
    right: 25px;    
    z-index: 101;    
    border-radius: 1px;
    line-height: 0.85;
    font-size: 50px;
    text-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
    color: rgb(255, 255, 255);
    cursor: pointer;
}

@media screen and (min-width: 1201px) and (max-width: 1366px) {
    .homeCarousel .slide {
        height: 500px;
    }
}

@media screen and (min-width: 1px) and (max-width: 1200px) {
      .homeCarousel .slide {
        height: 500px;
    }
    
    .homeCarousel .pager {
        bottom: 20px;
    }
    
    .homeCarousel .prev, .homeCarousel .next {
        display: none;
    }
}
</style>
